import { BULK_ACTION_IDS_PROP } from '@blaze-shared/elements-domain';
import { type Connection, type Workflow } from '@blaze-shared/workflow-domain';

const BULK_SELECTION_INPUT = BULK_ACTION_IDS_PROP.replace(/^\$\$/, '');

export const DEFAULT_SUPPORTED_INPUTS_MAP = new Map<string, string>([
  ['$selected', 'selectedRow'],
  ['$selectedIds', BULK_SELECTION_INPUT],
]);

export function processWorkflowInputs(
  workflow: Workflow,
  connection: Connection,
  idsMapping: Record<string, string>,
  supportedInputs: Map<string, string> = DEFAULT_SUPPORTED_INPUTS_MAP,
  onlyInput?: string,
): boolean {
  if (!workflow.inputs) {
    return false;
  }

  const inputNames = Object.keys(workflow.inputs).filter(
    (input) => input.startsWith('Layout#') && (onlyInput === undefined || input === onlyInput),
  );

  if (inputNames.length === 0) {
    return false;
  }

  let hasModifications = false;
  let nodesStringified = JSON.stringify(workflow.nodes);

  for (const inputName of inputNames) {
    const [, componentName, encodedInput] = inputName.split('#');
    const input = decodeURIComponent(encodedInput);
    const elementId = idsMapping[componentName];
    const newInputName = supportedInputs.get(input);

    // Only a self-reference binds here: `connection` is the acting element's own connection, so an
    // input naming a different component must be left for the cross-component wiring pass.
    if (!elementId || !newInputName || elementId !== connection.source.id) {
      continue;
    }

    hasModifications = true;

    delete workflow.inputs[inputName];
    nodesStringified = nodesStringified.replaceAll(inputName, newInputName);
    workflow.inputs[newInputName] = connection.id;
  }

  if (hasModifications) {
    workflow.nodes = JSON.parse(nodesStringified);
  }

  const inputKeys = Object.keys(workflow.inputs);
  if (inputKeys.length === 1 && inputKeys[0] === 'selectedRow') {
    workflow.inputs['input1'] = workflow.inputs['selectedRow'];
    hasModifications = true;
  }

  return hasModifications;
}
